import { children, JSXElement } from "solid-js"
import './st-tool-button.css';

export class STToolButtonParams {
    icon: string = '';
    label: string = '';
    children?: JSXElement;
    onClick: (this: HTMLButtonElement, event: MouseEvent) => void = () => { };
}

export default function STToolButton(params: STToolButtonParams) {
    const content = children(() => params.children)

    return <button class="btn btn-link st-tool-button"
        aria-label={params.label}
        onClick={params.onClick}
        use:tooltip={params.label}>

        <i class={params.icon}></i>
        {content()}
    </button>
}


STToolButton.defaultProps = new STToolButtonParams();